module.exports = __webpack_public_path__ + "static/icon-hgtv-66abd0240197a840c5cea97cf50a65f0.svg";